import React, { useEffect } from 'react';
import { NavLink, withRouter, useHistory } from 'react-router-dom';
import appLogo from '../images/logo.png';
import Logout from './user/Logout';
import { AuthUserContext } from './session';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronLeft, faSignInAlt, faAd } from '@fortawesome/free-solid-svg-icons';
import { faKey } from '@fortawesome/free-solid-svg-icons';


const Navigation = (props) => {

    useEffect(() => {
        props.history.listen(() => {
            if (window.swUpdateReady) {
                window.swUpdateReady = false;
                window.stop();
                window.location.reload();
            }
        });
    }, [])

    return (
        <AuthUserContext.Consumer>
            {authUser =>
                <MainNavigation authUser={authUser} {...props} />
            }
        </AuthUserContext.Consumer >
    )
}

const MainNavigation = (props) => {
    const { pathname } = props.location;
    const { authUser } = props;

    let history = useHistory()

    const goBack = () => {
        history.goBack();
    }

    const navColorClass = authUser && authUser.token && authUser.token.admin ? "bg-admin" : "bg-app"

    const logoComponent = <>
        <NavLink className="navbar-brand" to="/">
            <img src={appLogo} height="25" className="d-inline-block mr-3" alt="" />
            <span className="font-weight-bolder">FairPlay</span>
        </NavLink>
        {/* <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation"> */}
        {/* <span className="navbar-toggler-icon"></span> */}
        {/* <FontAwesomeIcon icon={faEllipsisV} color="white" /> */}
        {/* </button> */}
    </>

    const navItems = authUser ?
        <NavigationAuth authUser={authUser} pathname={pathname} />
        :
        <NavigationNonAuth />


    return (
        <nav className={"navbar navbar-dark pl-1 pr-1 " + navColorClass}>
            <div className="navbar-brand btn btn-link mr-1 pr-2 pl-2" onClick={goBack}>
                <FontAwesomeIcon icon={faChevronLeft} color="white" />
            </div>
            {logoComponent}
            {navItems}
        </nav>
    );
}

const NavigationAuth = (props) => {
    const { pathname, authUser } = props;

    const admin = authUser.token && authUser.token.admin;
    const premium = authUser.token && authUser.token.premium;

    function match(path) {
        return (pathname.startsWith(path)) ? "text-white-50" : "text-white";
    }

    if (admin) {
        return (
            // <div className="collapse navbar-collapse justify-content-end" id="navbarToggler">
            <div className="d-flex flex-md-fill justify-content-end" id="navbarToggler">
                <ul className="nav justify-content-end ">

                    <li className="nav-item">
                        <NavLink className={'nav-link ' + (match("/ads"))} to="/ads">
                            <FontAwesomeIcon className="d-inline d-md-none" icon={faAd} />
                            <span className="d-none d-md-inline" >Publicidad</span>
                        </NavLink>
                    </li>

                    <UserNavItem match={match} pathname={pathname} authUser={authUser} />
                </ul>
            </div >
        )
    }

    if (premium) {
        return (
            // <div className="collapse navbar-collapse justify-content-end" id="navbarToggler">
            <div className="d-flex flex-md-fill justify-content-end" id="navbarToggler">
                <ul className="nav justify-content-end ">
                    <li className="nav-item">
                        {/* <NavLink className={'nav-link ' + (match("/tournaments"))} to="/tournaments">Torneos</NavLink> */}
                    </li>

                    <UserNavItem match={match} pathname={pathname} authUser={authUser} />

                </ul>
            </div>
        )
    }
};

const UserNavItem = ({ match, pathname, authUser }) => {

    let email = authUser.email;
    email = email.substring(0, email.indexOf('@'));

    return (
        <li className="nav-item dropdown ">
            <a href="#" className={'btn btn-link nav-link dropdown-toggle border-0 ' + (match("/passwordchange"))} data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                <FontAwesomeIcon className="mr-1" icon={faUser} />
                <span className="d-none d-md-inline">{email}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
                <NavLink className="dropdown-item" to='/passwordchange'>
                    <FontAwesomeIcon className="mr-1" icon={faKey} />
                    <span>Cambiar Contraseña</span>
                </NavLink>
                <div className="dropdown-divider" />
                <Logout />
            </div>
        </li>
    )
}

const NavigationNonAuth = () => (
    <div className="d-flex flex-md-fill justify-content-end" id="navbarToggler">
        <ul className="nav justify-content-end ">
            <li className="nav-item">
                <NavLink className="nav-link active text-light pr-1" to="/login">
                    <FontAwesomeIcon className="mr-1" icon={faSignInAlt} />
                    <span className="d-none d-md-inline">Iniciar Sesión</span>

                </NavLink>
            </li>
        </ul>
    </div>
);

export default withRouter(Navigation);